// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-xl[data-v-2f58e001]  a:not(.btn):not(:hover){text-decoration:underline}.card-custom[data-v-2f58e001]{padding:32px;height:100%;display:flex;flex-direction:column}.card-custom[data-v-2f58e001]  a{font-weight:400;color:inherit;text-decoration:underline;transition:all .2s ease-in-out;text-decoration-thickness:1px;text-underline-position:from-font}.card-custom[data-v-2f58e001]  a:hover{text-decoration-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
